// This file is automatically generated. Do not edit it directly.
import { createBrowserClient } from '@supabase/ssr';
import type { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file and ensure VITE_SUPABASE_URL and VITE_SUPABASE_KEY are set correctly.'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Get the domain for cookie sharing
const getAppDomain = () => {
  if (typeof window === 'undefined') return 'wattfactory.tech';
  
  const hostname = window.location.hostname;
  // For production domains (wattfactory.tech, *.wattfactory.tech)
  if (hostname.includes('wattfactory.tech')) {
    return '.wattfactory.tech';
  }
  // For Vercel preview domains
  if (hostname.includes('vercel.app')) {
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      // Extract the main domain for vercel (e.g. "app-name.vercel.app")
      return `.${parts.slice(-3).join('.')}`;
    }
  }
  // For localhost/development
  return undefined; // Let browser handle default
};

export const supabase = createBrowserClient<Database>(supabaseUrl, supabaseKey, {
  cookieOptions: {
    domain: getAppDomain(),
    path: '/',
    sameSite: 'lax',
    secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
    maxAge: 100000000, // Long-lived session
  },
});

// Make supabase client available globally for debugging
if (typeof window !== 'undefined') {
  (window as any).supabase = supabase;
}